// TOOD: convert to typescript. this file is heavily dependent on redux-form fields
// this file should be addressed in a separate MR once redux-form has been replaced

import React from 'react';

import _ from 'lodash';
import { FormGroup } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

import DateOfBirthQuestion from './DateOfBirthQuestion';
import HouseNumberQuestion from './HouseNumberQuestion';
import MainPhoneQuestion from './MainPhoneQuestion';
import NameQuestion from './NameQuestion';
import messagesDE from './PersonalInformationDE.messages';
import PostcodeQuestion from './PostcodeQuestion';
import SecondaryPhoneQuestion from './SecondaryPhoneQuestion';
import StreetLineOneQuestion from './StreetLineOneQuestion';
import StreetLineTwoQuestion from './StreetLineTwoQuestion';
import TownQuestion from './TownQuestion';
import FormField from '../../components/FormField/';
import messages from '../PersonalInformation/PersonalInformation.messages';

class Person extends React.Component {
    handleHasOtherIncomeSelectChange = (hasOtherIncome) => {
        /* To take advantage of yup's validators, "has_other_income" needs to be a redux-form field. This field isn't
         * saved in the Lending API state, however. This means that we need a separate redux action to update the
         * UI state, too (updateBusinessIncomeState handles this).
         * */
        this.props.person.has_other_income.onChange(hasOtherIncome);
        this.props.updateBusinessIncomeState(hasOtherIncome);
    };

    renderMonthlyBusinessIncomeLabel() {
        const { intl } = this.props;
        switch (this.props.companyType) {
            case 'gmbh':
            case 'ug':
            case 'ltd':
            case 'kg':
            case 'gmbh_u_co_kg':
            case 'aktiengesellschaft':
            case 'kgaa':
                return intl.formatMessage(messagesDE.businessIncomeSalary);
            default:
                return intl.formatMessage(messagesDE.businessIncomeProfitShare);
        }
    }

    render() {
        const { person, className } = this.props;

        const currentAddress = person.addresses[0];
        const mainPhoneNumber = _.find(person.phone, {
            type: { value: 'main' }
        });
        const secondaryPhoneNumber = _.find(person.phone, {
            type: { value: 'secondary' }
        });

        return (
            <div className={className}>
                <FormGroup>
                    <NameQuestion
                        titleField={person.title}
                        firstNameField={person.first_name}
                        lastNameField={person.last_name}
                    />
                    <DateOfBirthQuestion field={person.date_of_birth} />
                </FormGroup>
                <FormGroup>
                    <MainPhoneQuestion field={mainPhoneNumber.number} />
                    <SecondaryPhoneQuestion
                        field={secondaryPhoneNumber.number}
                    />
                </FormGroup>
                <FormGroup>
                    <FormField.Header
                        message={
                            <FormattedMessage {...messages.personalAddress} />
                        }
                    />
                    <StreetLineOneQuestion
                        field={currentAddress.street_line_1}
                    />
                    <HouseNumberQuestion field={currentAddress.house_number} />
                </FormGroup>
                <FormGroup>
                    <StreetLineTwoQuestion
                        field={currentAddress.street_line_2}
                    />
                    <PostcodeQuestion field={currentAddress.postcode} />
                </FormGroup>
                <FormGroup>
                    <TownQuestion field={currentAddress.town} />
                </FormGroup>
            </div>
        );
    }
}

export default injectIntl(Person);
